import {FactoryProvider} from "@angular/core";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {Kontekst} from "felles/tjenester/Kontekst";
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {Språkvalg, SpråkvalgAvhengigheter} from "felles/tjenester/i18n/Spraakvalg";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {Tidssonevalg} from "felles/tjenester/i18n/Tidssonevalg";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {RedigerMøtemalDialogTjeneste} from "web/moduler/gruppe/modale/redigerMøtemalDialog/redigerMøtemalDialog";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {ajs_$rootScope_DI_TOKEN} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {ajs_$log_DI_TOKEN} from "web-ng2/tjenester/ajs/AjsLogService";
import {Bygginformasjon} from "felles/infrastruktur/Bygginformasjon";
import {LokaltDatalager} from "felles/tjenester/LokaltDatalager";
import {StrengMaler} from "felles/tjenester/StrengMaler";
import {StandardRequestHeadereHttpInterceptorAvhengigheter} from "felles/infrastruktur/StandardRequestHeadereInterceptorAvhengigheter";
import {MøteTjeneste} from "web/moduler/møte/MøteTjeneste";
import {Autentisering} from "felles/tjenester/Autentisering";
import {ajs_$mdDialog_DI_TOKEN} from "web-ng2/tjenester/ajs/AjsMdDialogService";
import {ajs_AjsUIRouterGlobals_DI_TOKEN} from "web-ng2/tjenester/ajs/AjsUIRouterGlobals";
import {PdfjsMeldingshåndtering} from "felles/tjenester/PdfjsMeldingshåndtering";
import {ajs_WebNavigasjon_DI_TOKEN} from "web-ng2/tjenester/ajs/AjsWebNavigasjon";
import {ajs_ModelloppdateringTjeneste_DI_TOKEN} from "felles-ng2/tjenester/ajs/AjsModelloppdateringTjeneste";
import IInjectorService = angular.auto.IInjectorService;
import {ajs_$transitions_DI_TOKEN} from "web-ng2/tjenester/ajs/AjsTransitionService";
import {ajs_$state_DI_TOKEN} from "web-ng2/tjenester/ajs/AjsStateService";

const debug = initDebugger('ajs tjenesteoppgraderinger');


/** Angularjs (Ajs) tjenester som benyttes i Angular-kode. */
export function oppgraderteAjsTjenester() {
    return [
        oppgraderAjsTjenesteMedRegnavn(ajs_$rootScope_DI_TOKEN, regNavn.ng.$rootScope),
        oppgraderAjsTjenesteMedRegnavn(ajs_$log_DI_TOKEN, regNavn.ng.$log),
        oppgraderAjsTjenesteMedRegnavn(ajs_$mdDialog_DI_TOKEN, regNavn.md.$mdDialog),
        oppgraderAjsTjenesteMedRegnavn(ajs_AjsUIRouterGlobals_DI_TOKEN, regNavn.ng.ui.$uiRouterGlobals),
        oppgraderAjsTjenesteMedRegnavn(ajs_WebNavigasjon_DI_TOKEN, WebNavigasjon.regNavn),
        oppgraderAjsTjenesteMedRegnavn(ajs_ModelloppdateringTjeneste_DI_TOKEN, ModelloppdateringTjeneste.regNavn),
        oppgraderAjsTjenesteMedRegnavn(ajs_$transitions_DI_TOKEN, regNavn.ng.ui.$transitions),
        oppgraderAjsTjenesteMedRegnavn(ajs_$state_DI_TOKEN, regNavn.ng.ui.$state),
        oppgraderAjsTjeneste(Bygginformasjon),
        oppgraderAjsTjeneste(Konfigurasjon),
        oppgraderAjsTjeneste(StandardRequestHeadereHttpInterceptorAvhengigheter),
        oppgraderAjsTjeneste(Kontekst),
        oppgraderAjsTjeneste(MeldingTilBruker),
        oppgraderAjsTjeneste(Språkvalg),
        oppgraderAjsTjeneste(SpråkvalgAvhengigheter),
        oppgraderAjsTjeneste(Tidssonevalg),
        oppgraderAjsTjeneste(RedigerMøtemalDialogTjeneste),
        oppgraderAjsTjeneste(LokaltDatalager),
        oppgraderAjsTjeneste(StrengMaler),
        oppgraderAjsTjeneste(MøteTjeneste),
        oppgraderAjsTjeneste(Autentisering),
        oppgraderAjsTjeneste(PdfjsMeldingshåndtering)
    ];
}


export function oppgraderAjsTjeneste(tjenesteklasse: any): FactoryProvider {
    return oppgraderAjsTjenesteMedRegnavn(tjenesteklasse, tjenesteklasse.regNavn);
}

export function oppgraderAjsTjenesteMedRegnavn(tjenesteklasse: any, tjenestenavn: string): FactoryProvider {
    debug(`oppgradere ajs tjeneste "${tjenestenavn}"`)
    return {
        provide: tjenesteklasse,
        useFactory: (i: IInjectorService) => i.get(tjenestenavn),
        deps: [regNavn.ng.$injector]
    };
}
